import { render, staticRenderFns } from "./DummyCofocus.vue?vue&type=template&id=7fb8fdda&scoped=true&"
import script from "./DummyCofocus.vue?vue&type=script&lang=js&"
export * from "./DummyCofocus.vue?vue&type=script&lang=js&"
import style0 from "./DummyCofocus.vue?vue&type=style&index=0&id=7fb8fdda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb8fdda",
  null
  
)

export default component.exports